import React, { useEffect, useState } from 'react'
import style from './style'
import propTypes from './prop'
import { Icon } from '@iconify/react'
import { withStyles, Paper, InputAdornment } from '@material-ui/core'
import translator from 'src/translate'
import { CoreTextField } from 'src/components/core'
/**
 *
 * @param {*} props
 */
const SearchInput = props => {
  const { classes, searchTextExecute } = props
  const [searchText, setSearchText] = useState('')
  const [query, setQuery] = useState('')

  useEffect(() => {
    const timeOutId = setTimeout(() => setQuery(searchText), 1000)
    return () => clearTimeout(timeOutId)
  }, [searchText])

  useEffect(() => {
    searchTextExecute(query)
  }, [query])

  const handleKeyDown = event => {
    if (event.keyCode === 13) {
      searchTextExecute(query)
    }
  }

  const handleChange = event => {
    setSearchText(event.currentTarget.value)
  }

  return (
    <Paper className={classes.root}>
      <CoreTextField
        value={searchText}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        size="small"
        placeholder={translator._('general.searchDots')}
        className={classes.search}
        marginTop={false}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon icon="mdi:search" />
            </InputAdornment>
          ),
        }}
      />
    </Paper>
  )
}

SearchInput.propTypes = propTypes

export default withStyles(style)(SearchInput)
